export const MME_MODULE = 'MME';
export const SELECT_MEDIA_VEHICLES = 'Select Media Vehicles';
export const SELECT_REPORT_OPTIONS = 'Select Report Options';
export const MEDIA_VEHICLE_OPTIONS = [
  { value: 'TV Networks', label: 'TV Networks' },
  { value: 'TV Programs', label: 'TV Programs' },
  { value: 'Websites', label: 'Websites' },
  { value: 'Magazines', label: 'Magazines' },
  { value: 'Streaming', label: 'Streaming' },
];
export const REPORT_TYPE_LABEL = 'Report Type';
export const REPORT_TYPE_OPTIONS = [
  { value: 'SR', label: 'Statement' },
  { value: 'DR', label: 'Engagement Score' },
  { value: 'DCR', label: 'Engagement Score % Composition' },
];
export const REPORT_TYPE_OPTIONS_MAP = {
  SR: 'Statement',
  DR: 'Engagement Score',
  DCR: 'Engagement Score % Composition',
};
export const DIMENSION_OPTIONS = [
  { value: 0, label: 'General' },
  { value: 1, label: 'TV' },
  { value: 2, label: 'Website' },
  { value: 3, label: 'Magazine' },
  { value: 4, label: 'Streaming' }];
export const DIMENSION_OPTIONS_MAP = {
  0: 'General',
  1: 'TV',
  2: 'Website',
  3: 'Magazine',
  4: 'Streaming',
};
export const STATEMENT_DATA_LABEL = 'Statement Variables';
export const STATEMENT_DATA_LIST = [
  {
    id: 'stmt-1',
    value: 'Top2',
    label: 'Top 2',
    checked: false,
    childNode: true,
    customClass: 'none-checked',
    children: [
      {
        id: 'stmt-2',
        pId: 'stmt-1',
        value: '0',
        label: 'Very Descriptive',
        checked: false,
      },
      {
        id: 'stmt-3',
        pId: 'stmt-1',
        value: '1',
        label: 'Descriptive',
        checked: false,
      },
    ],
  },
  {
    id: 'stmt-4',
    value: '2',
    label: 'Somewhat Descriptive',
    checked: false,
    customClass: 'none-checked',
  },
  {
    id: 'stmt-5',
    value: 'b2',
    label: 'Bottom 2',
    checked: false,
    childNode: true,
    customClass: 'none-checked',
    children: [
      {
        id: 'stmt-6',
        pId: 'stmt-5',
        value: '3',
        label: 'Slightly Descriptive',
        checked: false,
      },
      {
        id: 'stmt-7',
        pId: 'stmt-5',
        value: '4',
        label: 'Not at all Descriptive',
        checked: false,
      },
    ],
  },
];
export const STATEMENT_VARIABLE_MAP_TO_LABEL = {
  0: 'Very Descriptive',
  1: 'Descriptive',
  2: 'Somewhat Descriptive',
  3: 'Slightly Descriptive',
  4: 'Not at all Descriptive',
};
export const NO_STUDY_DATA_MESSAGE = `You do not currently have studies to the MME application. Please contact your 
  Account Manager to learn more about your studies.`;

export const PAGE_VISIT_MME = 'PAGE_VISIT_MME';
export const RUN_BUTTON_CLICK = 'RUN_BUTTON_CLICK';
export const MEDIA_VEHICLES_LABEL = 'MEDIA VEHICLE';
export const OBSERVATION_LABEL = 'OBSERVATION';
export const ALL_ROWS_LABEL = 'ALL ROWS';
export const ALL_ADULTS = 'ALL ADULTS';
export const STATEMENT_REPORT = 'Statement Report';
export const ENGAGEMENT_SCORE_REPORT = 'Engagement Score Report';
export const ENGAGEMENT_COMPOSITION_REPORT = 'Engagement Score % Composition Report';
export const ONE_MEDIA_VEHICLE = 'Selection of at least one media vehicle';
export const ONE_STATEMENT = 'Selection of at least one statement';
export const ONE_DIMENSION = 'Selection of at least one dimension';
export const ONE_STATEMENT_VARIABLE = 'Selection of at least one statement variable';
export const ONE_MAGAZINE = 'Selection of at least one magazine from the media vehicles list';
export const ONE_TELEVISION = 'Selection of at least one TV network or TV program from the media vehicles list';
export const ONE_WEBSITE = 'Selection of at least one website from the media vehicles list';
export const DESELECT_WEBSITE_MAGAZINE = 'Deselect all website and/or magazine properties';
export const DESELECT_TV_MAGAZINE = 'Deselect all tv and/or magazine properties';
export const DESELECT_TV_WEBSITE = 'Deselect all tv and/or website properties';
export const REPORT_TYPE_SR = 'SR';
export const REPORT_TYPE_DR = 'DR';
export const REPORT_TYPE_DCR = 'DCR';
export const RUN_CLICKED = 'Run Clicked';
export const STATEMENT_REPORT_RUN = 'STATEMENT_REPORT';
export const ENGAGEMENT_SCORE_REPORT_RUN = 'ENGAGEMENT_SCORE_REPORT';
export const ENGAGEMENT_SCORE_COMPOSITION_REPORT_RUN = 'ENGAGEMENT_SCORE_%_COMPOSITION_REPORT';
export const MME_VALIDATE_MODAL_HEADING = `Some of the selected bases or targets are not available in the 
  requested study.`;
export const MME_VALIDATE_MODAL_CONTINUE_LABEL = `Click CONTINUE to open the requested study. All non-transferable 
  bases and targets will be removed and all other report selections will be reset.`;
export const MME_VALIDATE_MODAL_CANCEL_LABEL = `Click CANCEL to return to your previous study and 
  maintain their current analysis.`;
export const MME_VALIDATE_MODAL_VIEWER_CONTINUE_LABEL = `Click CONTINUE to return to the editor and proceed with the 
  change study request. Validated bases and targets will be transferred but all other 
  report selections will be reset. We strongly suggest exporting your analysis prior to proceeding.`;
export const STATEMENTS = 'statements';
export const DIMENSIONS = 'dimensions';
export const NO_ADS_STREAMING = ['APPLE TV+', 'DISNEY+', 'NETFLIX',
  'PRIME VIDEO (AMAZON)', "HBO (ANY PROGRAM)", 'SHOWTIME (ANY PROGRAM)', 'STARZ (ANY PROGRAM)', 'HBO MAX*'];
export const DESELECT_NO_AD_STREAMING = "Deselecting Apple TV+, Disney+, HBO/HBO Max, Netflix, Showtime, Starz, or Prime Video";
export const DESELECT_GA_STATEMENT = "Deselecting any statement or score with (GA) labeling";